import {ModeleClient, ModeleTypePiece} from './Models'
import moment from 'moment'
import {UserModel} from '../app/modules/auth'

export const toGmapQuery = (terms: string) => {
  return terms.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ' ');
}

export const formatTypePiecePourDemande = (typePiece: ModeleTypePiece): string => {
  var nompiece = "[";

  if (typePiece.sousCategorie?.categorie?.code !== undefined && typePiece?.sousCategorie?.categorie?.code !== null) {
    nompiece += typePiece?.sousCategorie?.categorie?.code;
  }
  if (typePiece?.sousCategorie?.code !== undefined && typePiece?.sousCategorie?.code !== null) {
    nompiece += typePiece?.sousCategorie?.code;
  }
  if (typePiece?.code !== undefined && typePiece?.code !== null) {
    nompiece += typePiece?.code;
  }

  nompiece += "] - " + typePiece?.nom;

  return nompiece
}

export const formatTypePieceSansNom = (typePiece: ModeleTypePiece): string => {
  var nompiece = ""

  if (typePiece?.sousCategorie?.categorie?.code !== undefined && typePiece?.sousCategorie?.categorie?.code !== null) {
    nompiece += typePiece?.sousCategorie?.categorie?.code;
  }

  if (typePiece?.sousCategorie?.code !== undefined && typePiece?.sousCategorie?.code !== null) {
    nompiece += typePiece?.sousCategorie?.code;
  }
  if (typePiece?.code !== undefined && typePiece?.code !== null) {
    nompiece += typePiece?.code;
  }
  return nompiece
}

export const formatDate = (dateTimeStr: string): string => {
  return moment(dateTimeStr).format("DD/MM/YYYY")
}

export const formatDateTime = (dateTimeStr: string): string => {
  return moment(dateTimeStr).format("DD/MM/YYYY HH:mm")
}

export const shouldDisplayModule = (
  user: UserModel | undefined,
  module: string,
  fonctionnalite?: string
): boolean => {
  if (!fonctionnalite) {
    if (user !== undefined && user.listeModules !== undefined) {
      return user?.listeModules?.includes(module);
    }
  } else {
    // Synchronisation en temps réel avec la modification des fonctionnalités dans "Rôles utilisateurs"
    return !!(user?.listeUserPermissions?.includes(fonctionnalite));
  }

  return false;
}

export const shouldDisplayFonctionnalite = (user: UserModel | undefined, fonctionnalite: string): boolean => {
  if (user !== undefined && user.listeUserPermissions !== undefined) {
    return user?.listeUserPermissions?.includes(fonctionnalite);
  }

  return false;
}

export const transformToValueLabel = (adresse) => {
  return {
    value: adresse?.id,
    label: adresse?.libelle ?? adresse?.adresse,
  }
}

// Récupération source demande devis
export const computeSource = (utilisateurAssigne, client: ModeleClient) => {
  let isAuto = false
  let isMoto = false
  let isIndus = false

  const sourcesUtilisateur: any = utilisateurAssigne?.listeSources?.[0] || []
  const countSourceUtilisateurs = sourcesUtilisateur.length

  // Codes client
  const codes = {
    AUTO: client?.codeClientAAuto ? 'AUTO' : null,
    MOTO: client?.codeClientAMoto ? 'MOTO' : null,
    INDUSTRIE: client?.codeClientAIndus ? 'INDUSTRIE' : null,
  }
  // Codes non null
  const codesNotNull = Object.values(codes).filter((v) => v !== null)
  const countCodeClientNotNull = codesNotNull.length

  let source: any = null

  if (
    countSourceUtilisateurs === 1 ||
    (countSourceUtilisateurs > 1 && countCodeClientNotNull > 1) ||
    (countSourceUtilisateurs > 0 && countCodeClientNotNull === 0)
  ) {
    source = sourcesUtilisateur[0]

    isAuto = source === 'AUTO'
    isMoto = source === 'MOTO'
    isIndus = source === 'INDUSTRIE'
  } else if (countCodeClientNotNull === 1 && countSourceUtilisateurs > 1) {
    source = codesNotNull[0]

    isAuto = source === 'AUTO'
    isMoto = source === 'MOTO'
    isIndus = source === 'INDUSTRIE'
  } else if (countSourceUtilisateurs === 0 && countCodeClientNotNull >= 1) {
    source = codesNotNull?.[0]

    isAuto = source === 'AUTO'
    isMoto = source === 'MOTO'
    isIndus = source === 'INDUSTRIE'
  } else {
    isAuto = true
  }

  return {isAuto, isMoto, isIndus, source}
}

// Récupération numero devis à partir objet email
export const getNumDemandeDevis = (emailObject) => {
  const match = emailObject?.match(/DEV-\d+/)

  return match?.[0] ?? ''
}

export const getDemandeFlagColor = (clientDemande, delaisTraitement) => {
  let colorFlag = null
  if (delaisTraitement?.length > 0) {
    // Si le delai avant traitement réel dépasse le délai de avant traitement
    // Ou si maintenant dépasse le delai avant traitement
    if (
      (moment(clientDemande?.delaiAvantTraitementReel) >
        moment(clientDemande?.delaiAvantTraitement) ||
        moment() > moment(clientDemande?.delaiAvantTraitement)) &&
      clientDemande?.clientDemandeEtape?.code === 'NOUVE'
    ) {
      colorFlag = delaisTraitement?.find(
        (item) => item?.typeDelaiTraitementDemande?.code === 'AVT'
      )?.couleur
    }

    // Si le delai traitement réel dépasse le délai de traitement
    // Ou si maintenant dépasse le delai traitement
    if (
      (moment(clientDemande?.delaiTraitementReel) > moment(clientDemande?.delaiTraitement) ||
        moment() > moment(clientDemande?.delaiTraitement)) &&
      clientDemande?.clientDemandeEtape?.code === 'ASSIG'
    ) {
      colorFlag = delaisTraitement?.find(
        (item) => item?.typeDelaiTraitementDemande?.code === 'TRT'
      )?.couleur
    }
  }
  return colorFlag
}

export type DemandesFilters = {
  dateDebut: string | null
  dateFin: string | null
  allDemandes: boolean
  statut: any
  source: any
  searchPage: string
  searchId: string
  centre: any
  equipes: any
  tri: {
    key: string | undefined
    order: string | undefined
  },
  shareWithTeam: any
  statusMode: string | undefined
}

let savedFilters: DemandesFilters | undefined

// Sauvegarder les filtres appliquées temporairement
export const saveFilters = (filters: DemandesFilters) => {
  savedFilters = filters
}
export const loadFilters = () => savedFilters
export const clearFilters = () => {
  savedFilters = undefined
}